(() => {
  const CONFIG_SELECTOR = '[data-eg-digital-cart-ux-config]';
  const BADGE_SELECTOR = '[data-eg-cart-line-type-badge]';
  const CART_ROWS_SELECTOR = '#main-cart-items .cart-item, #CartDrawer-CartItems .cart-item';
  let cartRequest = null;
  let refreshTimer = null;

  const readConfig = () => {
    const node = document.querySelector(CONFIG_SELECTOR);
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (_) { return null; }
  };

  const cartRoot = () => window.Shopify?.routes?.root || '/';

  const fetchCart = () => {
    if (cartRequest) return cartRequest;
    cartRequest = fetch(`${cartRoot()}cart.js`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then((response) => {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .finally(() => { cartRequest = null; });
    return cartRequest;
  };

  const removeBadges = () => {
    document.querySelectorAll(BADGE_SELECTOR).forEach((node) => node.remove());
  };

  const addBadgeToRow = (row, type, label) => {
    const details = row?.querySelector('.cart-item__details');
    if (!details || details.querySelector(BADGE_SELECTOR)) return;

    const badge = document.createElement('span');
    badge.className = `eg-cart-line-type-badge eg-cart-line-type-badge--${type}`;
    badge.dataset.egCartLineTypeBadge = '';
    badge.textContent = label;
    badge.setAttribute('aria-label', `Tipo de producto: ${label}`);

    const title = details.querySelector('.cart-item__title');
    if (title) title.insertAdjacentElement('afterend', badge);
    else details.prepend(badge);
  };

  const renderBadges = (cart, config) => {
    removeBadges();
    if (!config || config.enabled === false || config.showLineTypeBadges === false) return;

    const items = Array.isArray(cart?.items) ? cart.items : [];
    const hasDigital = items.some((item) => item.requires_shipping === false);
    if (!hasDigital) return;

    items.forEach((item, index) => {
      const isDigital = item.requires_shipping === false;
      const type = isDigital ? 'digital' : 'physical';
      const label = isDigital
        ? String(config.digitalLineBadgeText || 'DIGITAL').trim()
        : String(config.physicalLineBadgeText || 'FÍSICO').trim();
      if (!label) return;

      const position = index + 1;
      addBadgeToRow(document.querySelector(`#CartItem-${position}`), type, label);
      addBadgeToRow(document.querySelector(`#CartDrawer-Item-${position}`), type, label);
    });
  };

  const refresh = () => {
    refreshTimer = null;
    const config = readConfig();
    if (!config || config.enabled === false || config.showLineTypeBadges === false) {
      removeBadges();
      return;
    }
    if (!document.querySelector(CART_ROWS_SELECTOR)) {
      removeBadges();
      return;
    }

    fetchCart()
      .then((cart) => renderBadges(cart, config))
      .catch(() => {});
  };

  const scheduleRefresh = (delay = 30) => {
    if (refreshTimer) window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, delay);
  };

  const addedNodeTouchesCart = (node) => {
    if (!(node instanceof Element)) return false;
    if (node.matches('.cart-item, #main-cart-items, #CartDrawer-CartItems')) return true;
    return Boolean(node.querySelector('.cart-item, #main-cart-items, #CartDrawer-CartItems'));
  };

  const observer = new MutationObserver((mutations) => {
    const relevant = mutations.some((mutation) => [...mutation.addedNodes].some(addedNodeTouchesCart));
    if (relevant) scheduleRefresh(50);
  });

  const bindEvents = () => {
    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      if (target.closest('#cart-icon-bubble, cart-remove-button, quantity-input, .quantity__button')) {
        scheduleRefresh(450);
      }
    });

    document.addEventListener('change', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (target?.closest('#main-cart-items, #CartDrawer-CartItems')) scheduleRefresh(450);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => scheduleRefresh(80));
    }
  };

  const init = () => {
    bindEvents();
    observer.observe(document.documentElement, { childList: true, subtree: true });
    scheduleRefresh(0);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', () => scheduleRefresh(0));
})();
